import React from "react";

const STEPS = [
  { key: 1, label: "Acceso" },
  { key: 2, label: "Verificación" },
  { key: 3, label: "Código" },
];

/**
 * Stepper visual del wizard de login admin. Muestra los 3 pasos del flujo 2FA
 * con estados: pendiente, actual, completado. Es solo presentacional — la
 * navegación entre pasos la controla LoginForm, no el stepper.
 */
export function AuthStepper({ currentStep }) {
  return (
    <ol className="auth-stepper" aria-label="Pasos de inicio de sesión">
      {STEPS.map((s) => {
        let modifier = "";
        if (s.key < currentStep) modifier = "auth-stepper__item--done";
        else if (s.key === currentStep)
          modifier = "auth-stepper__item--current";
        return (
          <li
            key={s.key}
            className={`auth-stepper__item ${modifier}`}
            aria-current={s.key === currentStep ? "step" : undefined}
          >
            <span className="auth-stepper__bullet" aria-hidden="true">
              {s.key < currentStep ? "✓" : s.key}
            </span>
            <span className="auth-stepper__label">{s.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
